<template>
  <div>
    <div v-if="file_surveilans_old">
      <div class="d-flex flex-between my-3">
        <h4 class="text-uppercase mb-0">Form Surveilans</h4>
        <router-link
          :to="
            `/operasi/form-surveilans/${$route.params.id_ralan}/${$route.params.id}?fromTab=6`
          "
          class="btn btn-with-icon-left btn-primary text-uppercase"
        >
          <i class="material-symbols-outlined">create</i>
          Ubah Form Surveilans
        </router-link>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div
              class="col-md-12 d-flex flex-between"
              v-if="file_surveilans_old"
            >
              <h5>Terupload: {{ title }}</h5>
              <a
                :href="file_surveilans_old"
                target="_blank"
                class="btn btn-outline btn-outline-secondary"
                >Download</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <EmptyState v-else :data="empty" />
  </div>
</template>

<script>
// import { setOperationIntro } from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import { dataOperasi } from "@/data/OperasiForm.js";
import EmptyState from "@/components/EmptyState.vue";
export default {
  props: { ralan: Object, operasi: Object },
  name: "OperasiFormObat",
  components: {
    EmptyState,
  },
  data: () => {
    return {
      empty: {
        img: "/img/nurse.svg",
        title: "Belum ada formulir surveilans",
        content:
          "Upload formulir surveilans dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/operasi/form-surveilans/",
        label: "upload formulir surveilans",
      },
      data: dataOperasi,
      detailTop: null,
      id_operasi: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      title: "",
      file_surveilans_old: "",
      formSet: {
        file_surveilans: null,
      },
    };
  },
  methods: {
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      ////console.log(this.formSet[e.target.name]);
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi/${this.$route.params.id}`
        );
        ////console.log(result);
        if (result.status == "200") {
          let self = this;
          Object.keys(this.formSet).forEach(function(key) {
            if (key == "file_surveilans") {
              self.file_surveilans_old =
                result.data["formatted_file_surveilans"];
              self.title = result.data["file_surveilans"];
            }
            if (key != "generate_form") {
              self.formSet[key] = result.data[key];
            }
          });
          ////console.log(self.formSet);
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
    },
  },
  mounted: async function() {
    this.empty.link +=
      this.$route.params.id_ralan + "/" + this.$route.params.id + "?fromTab=6";
    this.formSet["id_operasi"] = this.$route.params.id;
    await this.displayData();
  },
};
</script>
